import Cookies from './helpers/Cookies'
import simpleRestProvider from 'ra-strapi-rest';
// import { PostList } from './posts';
import { fetchUtils } from 'react-admin';
import {BASE_URL} from '../BASE_CONSTS';
import playerPlaceholder from '../assets/player-placeholder.svg';


const  uploadFields = [ "avatar" , "Post_image"];


export const authProvider = {

    login: async ({ username, password }) => {
        const identifier = username; // Strapi expects `identifier`.
        const request = new Request(`${BASE_URL}/auth/local`, {
            method: 'POST',
            body: JSON.stringify({ identifier, password }),
            headers: new Headers({ 'Content-Type': 'application/json' })
        });

        const response = await fetch(request);
        let payload = null;
        try {
            payload = await response.json();
        } catch (_error) {
            payload = null;
        }

        if (!response.ok) {
            const strapiMessage =
                payload?.message?.[0]?.messages?.[0]?.message ||
                payload?.message ||
                payload?.error ||
                response.statusText ||
                'Не удалось войти';
            throw new Error(strapiMessage);
        }

        if (!payload?.jwt || !payload?.user) {
            throw new Error('Strapi не вернул JWT или пользователя');
        }

        Cookies.setCookie('token', payload.jwt, 1);
        const avatar = payload.user?.avatar?.url
            ? BASE_URL + payload.user.avatar.url
            : playerPlaceholder;
        sessionStorage.setItem('auth', JSON.stringify({
            id: payload.user?.id,
            username: payload.user?.username,
            avatar,
        }));
        if (payload.user?.role?.name) {
            Cookies.setCookie('role', payload.user.role.name, 1);
        }

        // react-admin redirects after authProvider.login resolves. Do not reload here:
        // reloading before persisting the session races with the login flow.
        return Promise.resolve();
    },

    logout: () => {
        Cookies.deleteCookie('token');
        Cookies.deleteCookie('role');
        sessionStorage.removeItem("auth");
        return Promise.resolve();
    },

    checkAuth: () => {
        return Cookies.getCookie('token') ? Promise.resolve() : Promise.reject();
    },

    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            Cookies.deleteCookie('token');
            Cookies.deleteCookie('role');
            return Promise.reject();
        }
        return Promise.resolve();
    },

    getPermissions: () => {
        const role = Cookies.getCookie('role');
        return role ? Promise.resolve(role) : Promise.reject();
    },
    getIdentity: () => {
        try {
            const { id, username, avatar } = JSON.parse(sessionStorage.getItem('auth'));
            return Promise.resolve({ id, fullName:username, avatar });
        } catch (error) {
            return Promise.reject(error);
        }
    }
}

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = Cookies.getCookie('token')
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
}


export const dataProvider = simpleRestProvider(BASE_URL, httpClient, uploadFields )  ;
export default {dataProvider:dataProvider, authProvider:authProvider};